import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BookingSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { bookingData, requestId } = location.state || {};

  // If no booking data, redirect to home after a short delay
  React.useEffect(() => {
    if (!bookingData || !requestId) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000); // 3 second delay
      return () => clearTimeout(timer);
    }
  }, [bookingData, requestId, navigate]);

  if (!bookingData || !requestId) {
    return (
      <div className="min-h-screen pt-[100px] bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl text-gray-800 mb-4">Session expired</h1>
          <p className="text-gray-600 mb-4">
            Redirecting to home page in a moment...
          </p>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-opera-red text-white rounded-md hover:bg-opera-hover"
          >
            Return to Home Now
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-[100px] bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Success Message - Matching Email Style */}
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 mb-8">
          {/* Greeting Section - Exact Copy from Email */}
          <div className="max-w-2xl">
            <p
              className="text-3xl leading-relaxed mb-4 text-[#8c0000] font-light tracking-wide"
              style={{
                fontFamily: "Cormorant Garamond, serif",
                fontSize: "28px",
                lineHeight: "1.6",
                margin: "15px 0",
                fontWeight: "300",
                letterSpacing: "1px",
              }}
            >
              Dear {bookingData?.customerName || bookingData?.name || "Guest"},
            </p>

            <p
              className="text-base leading-relaxed mb-4 text-gray-800 font-light"
              style={{
                fontFamily: "Lato, Arial, sans-serif",
                fontSize: "16px",
                lineHeight: "1.6",
                margin: "15px 0",
                fontWeight: "300",
                color: "#333",
              }}
            >
              Thank you for your booking request on OperaToday.org.
            </p>

            <p
              className="text-base leading-relaxed mb-4 text-gray-800 font-light"
              style={{
                fontFamily: "Lato, Arial, sans-serif",
                fontSize: "16px",
                lineHeight: "1.6",
                margin: "15px 0",
                fontWeight: "300",
                color: "#333",
              }}
            >
              Our travel experts are now checking availability for your selected
              opera journey. We'll get back to you shortly with a personal
              confirmation
              {bookingData.isCustomInquiry
                ? " regarding your booking"
                : " and a secure link to complete your booking"}
              . You are just one step away from securing an unforgettable opera
              experience.
            </p>

            <p
              style={{
                fontSize: "16px",
                lineHeight: 1.6,
                margin: "5px 0",
                fontFamily: "'Lato', Arial, sans-serif",
                fontWeight: 300,
                color: "#333",
              }}
            >
              Best regards,
            </p>

            <div
              style={{
                backgroundImage: "url('/images/signiture_ot.png')",
                backgroundSize: "contain",
                backgroundPosition: "left",
                backgroundRepeat: "no-repeat",
                height: "60px",
                margin: "0 0 15px 0",
              }}
            ></div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <button
              onClick={() => navigate("/")}
              className="px-6 py-3 bg-[#8c0000] text-white rounded-md hover:bg-[#a50000] transition-colors"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              Return to Home
            </button>
            <button
              onClick={() => navigate("/opera-houses-and-festivals")}
              className="px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              Browse More Events
            </button>
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-gray-50 rounded-lg p-6 mt-6">
          <h3
            className="text-lg font-medium text-gray-800 mb-3"
            style={{ fontFamily: "Lato, sans-serif" }}
          >
            Need Help?
          </h3>
          <p
            className="text-sm text-gray-600 mb-4"
            style={{ fontFamily: "Lato, sans-serif" }}
          >
            If you have any questions about your booking or need to make changes, please don't hesitate to contact us.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="mailto:info@operatoday.org"
              className="text-sm text-[#8c0000] hover:text-[#a50000]"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              info@operatoday.org
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
